import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  logoutUser,
  useIsAuthenticated,
  useAppDispatch,
  useAppSelector,
} from "../../redux";

function UserMenu() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const menuRef = React.useRef();
  const user = useAppSelector((state) => state.auth.user);
  const isAdmin = user?.role === "admin";

  React.useEffect(() => {
    if (!open) return;
    function handleClick(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate("/");
  };

  return (
    <div
      className="dropdown"
      style={{ position: "relative", zIndex: 1050, overflow: "visible" }}
      ref={menuRef}
    >
      <button
        className=" theme-btn1 user-dropdown-btn"
        onClick={() => setOpen((o) => !o)}
      >
        <span className="user-dropdown-label">User</span>
        <span className="user-dropdown-caret">&#9662;</span>
      </button>
      {open && (
        <div
          className="dropdown-menu show user-dropdown-menu"
          style={{
            right: 0,
            left: "auto",
            minWidth: 160,
            position: "absolute",
            zIndex: 2000,
            display: "block",
          }}
        >
          <div className="user-dropdown-arrow"></div>
          <button
            className="dropdown-item user-dropdown-item"
            onClick={() => {
              setOpen(false);
              navigate(isAdmin ? "/admin-dashboard" : "/dashboard");
            }}
          >
            {isAdmin ? "Admin Dashboard" : "Dashboard"}
          </button>
          <div className="user-dropdown-divider"></div>
          <button
            className="dropdown-item user-dropdown-item"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
}

const Header = () => {
  const isAuthenticated = useIsAuthenticated();
  const user = useAppSelector((state) => state.auth.user);
  const isAdmin = user?.role === "admin";
  const dispatch = useAppDispatch();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Check authentication state when component mounts or auth state changes
  useEffect(() => {
    const checkAuthImmediately = () => {
      const token = localStorage.getItem("token");
      const userData = localStorage.getItem("userData");

      if (isAuthenticated && (!token || !userData)) {
        dispatch(logoutUser());
      }
    };

    checkAuthImmediately();
  }, [isAuthenticated, dispatch]);

  return (
    <>
      {/* HEADER START */}

      <div className="header-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="pera">
                <p>
                  <img src="/assets/img/icons/header-top-span.png" alt="" />{" "}
                  World’s Leading Forex Market Place
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <header>
        <div
          className="header-area header-area1 header-area-all d-none d-lg-block"
          id="header"
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="header-elements">
                  <div className="site-logo">
                    <a href="/">
                      <img src="/assets/img/logo/Logo-png-1.webp" alt="" />
                    </a>
                  </div>

                  <div className="main-menu-ex main-menu-ex1">
                    <ul>
                      <li>
                        <Link to="/">Home </Link>
                      </li>

                      <li className="dropdown-menu-parrent">
                        <Link to="/aboutus">About us </Link>
                      </li>

                      <li className="dropdown-menu-parrent">
                        <Link to="/plans&pricing">Plans & Pricing </Link>
                      </li>

                      <li className="dropdown-menu-parrent">
                        <Link to="/documentation">Documentation </Link>
                      </li>

                      <li className="dropdown-menu-parrent">
                        <Link to="/supported-pairs">Supported Pairs </Link>
                      </li>

                      {/* <li className="dropdown-menu-parrent"><Link to="/blog">Blog </Link>
                 </li> */}
                    </ul>
                  </div>

                  <div className="header1-buttons">
                    <div className="contact-btn d-none">
                      <div className="icon">
                        <img src="assets/img/icons/header1-icon.png" alt="" />
                      </div>
                      <div className="headding">
                        <p>Make a Call</p>
                        <a href="tel:124(555)6565">124 (555) 6565</a>
                      </div>
                    </div>
                    <div className="button">
                      <Link className="theme-btn1" to="/dashboard">
                        Start Free Plan{" "}
                        <span>
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </Link>
                    </div>
                    {!isAuthenticated && (
                      <div className="button">
                        <Link className="theme-btn1 ms-1" to="/login">
                          Login{" "}
                          <span>
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </Link>
                      </div>
                    )}
                    {isAuthenticated && (
                      <div className="button ms-1">
                        <UserMenu />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* HEADER END */}

      {/* Mobile Header Start */}
      <div className="mobile-header d-block d-lg-none">
        <div className="container-fluid">
          <div className="col-12">
            <div className="mobile-header-elements">
              <div className="mobile-logo">
                <Link to="/">
                  <img src="/assets/img/logo/Logo-png-1.webp" alt="" />
                </Link>
              </div>
              <div
                className="mobile-nav-icon"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                style={{ cursor: "pointer" }}
              >
                <i
                  className={
                    mobileMenuOpen ? "fa-solid fa-xmark" : "fa-solid fa-bars"
                  }
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Sidebar */}
      {mobileMenuOpen && (
        <div
          className="mobile-sidebar d-block d-lg-none mobile-menu-active"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            zIndex: 9999,
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div
            className="mobile-sidebar-content"
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              width: "100%",
              height: "100vh",
              backgroundColor: "rgb(2, 19, 52)",
              padding: "20px",
              overflowY: "auto",
              overflowX: "hidden",
              scrollbarWidth: "thin",
              scrollbarColor: "#4a5568 #2d3748",
            }}
          >
            <div className="logo-m">
              <Link to="/">
                <img src="/assets/img/logo/ibrlive-White.png" alt="" />
              </Link>
            </div>
            <div
              className="menu-close"
              onClick={() => setMobileMenuOpen(false)}
              style={{
                cursor: "pointer",
                position: "absolute",
                top: "20px",
                right: "20px",
                fontSize: "24px",
                color: "white",
              }}
            >
              <i className="fa-solid fa-xmark"></i>
            </div>
            <div className="mobile-nav" style={{ marginTop: "80px" }}>
              <ul>
                <li className="hash-has-sub">
                  <Link
                    to="/"
                    onClick={() => setMobileMenuOpen(false)}
                    className="hash-nav"
                  >
                    Home
                  </Link>
                </li>
                <li className="hash-has-sub">
                  <Link
                    to="/aboutus"
                    onClick={() => setMobileMenuOpen(false)}
                    className="hash-nav"
                  >
                    About Us
                  </Link>
                </li>
                <li className="hash-has-sub">
                  <Link
                    to="/plans&pricing"
                    onClick={() => setMobileMenuOpen(false)}
                    className="hash-nav"
                  >
                    Plans & Pricing
                  </Link>
                </li>
                <li className="hash-has-sub">
                  <Link
                    to="/documentation"
                    onClick={() => setMobileMenuOpen(false)}
                    className="hash-nav"
                  >
                    Documentation
                  </Link>
                </li>
                <li className="hash-has-sub">
                  <Link
                    to="/supported-pairs"
                    onClick={() => setMobileMenuOpen(false)}
                    className="hash-nav"
                  >
                    Supported Pairs
                  </Link>
                </li>
                <li className="hash-has-sub">
                  <Link
                    to="/blog"
                    onClick={() => setMobileMenuOpen(false)}
                    className="hash-nav"
                  >
                    Blog
                  </Link>
                </li>
                <li className="hash-has-sub">
                  <Link
                    to="/contact"
                    onClick={() => setMobileMenuOpen(false)}
                    className="hash-nav"
                  >
                    Contact
                  </Link>
                </li>
                {isAuthenticated && (
                  <li className="hash-has-sub">
                    <Link
                      to={isAdmin ? "/admin-dashboard" : "/dashboard"}
                      onClick={() => setMobileMenuOpen(false)}
                      className="hash-nav"
                    >
                      {isAdmin ? "Admin Dashboard" : "Dashboard"}
                    </Link>
                  </li>
                )}
              </ul>

              <div className="mobile-button hash-has-sub">
                <Link
                  className="menu-btn2 hash-nav"
                  to="/dashboard"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Start Free Plan{" "}
                  <span>
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </Link>
              </div>

              <div className="single-footer-items">
                <h3>Contact Us</h3>

                <div className="contact-box">
                  {/* <div className="icon">
                    <img src="/assets/img/icons/footer1-icon1.png" alt="" />
                  </div> */}
                  {/* <div className="pera hash-has-sub">
                    <a href="tel:0500222333" className="hash-nav">
                      0500 222 333
                    </a>
                  </div> */}
                </div>

                <div className="contact-box">
                  <div className="icon">
                    <img src="/assets/img/icons/footer1-icon2.png" alt="" />
                  </div>
                  <div className="pera hash-has-sub">
                    <a href="tel:9817800346" className="hash-nav">
                    9817800346
                    </a>
                  </div>
                </div>

                <div className="contact-box">
                  <div className="icon">
                    <img src="/assets/img/icons/footer1-icon3.png" alt="" />
                  </div>
                  <div className="pera hash-has-sub">
                    <a href="mailto:contact@ibrlive.com" className="hash-nav">
                    contact@ibrlive.com
                    </a>
                  </div>
                </div>

                <div className="contact-box">
                  <div className="icon">
                    <img src="/assets/img/icons/footer1-icon4.png" alt="" />
                  </div>
                  <div className="pera hash-has-sub">
                    <a href="https://ibrlive.com/" className="hash-nav">
                    https://ibrlive.com/
                    </a>
                  </div>
                </div>
              </div>

              <div className="contact-infos">
                {/* <h3>Our Location</h3> */}
                <ul className="social-icon">
                  <li className="hash-has-sub">
                    <a href="https://www.linkedin.com/company/ibrlive/" className="hash-nav">
                      <i className="fa-brands fa-linkedin-in"></i>
                    </a>
                  </li>
                  <li className="hash-has-sub">
                    <a href="https://twitter.com/ibr_live" className="hash-nav">
                      <i className="fa-brands fa-x-twitter"></i>
                    </a>
                  </li>
                  <li className="hash-has-sub">
                    <a href="https://www.facebook.com/ibrliveindia/" className="hash-nav">
                      <i className="fa-brands fa-facebook-f"></i>
                    </a>
                  </li>
                  <li className="hash-has-sub">
                    <a href="https://www.instagram.com/ibrlive/" className="hash-nav">
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Mobile Header End */}
    </>
  );
};

export default Header;

/* Enhanced User dropdown styles */
<style>{`
.user-dropdown-btn {
  padding: 8px 22px 8px 14px;
  background: linear-gradient(90deg, #f8fafc 60%, #e0e7ef 100%);
  border: 1.5px solid #cbd5e1;
  border-radius: 24px;
  font-weight: 700;
  color: #1a202c;
  font-size: 16px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  transition: border 0.2s, box-shadow 0.2s, transform 0.12s, filter 0.12s;
  cursor: pointer;
  outline: none;
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
}
.user-dropdown-btn:hover, .user-dropdown-btn:focus {
  border: 1.5px solid #2563eb;
  box-shadow: 0 6px 24px rgba(37,99,235,0.10);
  transform: scale(1.04);
  filter: brightness(1.04);
}
.user-dropdown-avatar {
  background: #2563eb;
  color: #fff;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 700;
  margin-right: 6px;
  box-shadow: 0 1px 4px rgba(37,99,235,0.10);
}
.user-dropdown-label {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.01em;
}
.user-dropdown-caret {
  margin-left: 8px;
  font-size: 13px;
  color: #64748b;
  transition: transform 0.2s;
}
.user-dropdown-menu {
  border-radius: 12px;
  box-shadow: 0 10px 32px rgba(0,0,0,0.16);
  padding: 0.5rem 0;
  background: #fff;
  border: 1.5px solid #e5e7eb;
  margin-top: 10px;
  position: absolute;
  min-width: 160px;
  right: 0;
}
.user-dropdown-arrow {
  position: absolute;
  top: -10px;
  right: 24px;
  width: 18px;
  height: 10px;
  overflow: hidden;
}
.user-dropdown-arrow::after {
  content: '';
  display: block;
  width: 14px;
  height: 14px;
  background: #fff;
  border-left: 1.5px solid #e5e7eb;
  border-top: 1.5px solid #e5e7eb;
  transform: rotate(45deg);
  margin: 2px auto 0 auto;
  box-shadow: 0 -2px 8px rgba(0,0,0,0.04);
}
.user-dropdown-item {
  font-size: 15.5px;
  padding: 10px 24px 10px 22px;
  color: #222;
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  font-weight: 500;
  transition: background 0.15s, color 0.15s;
}
.user-dropdown-item:hover, .user-dropdown-item:focus {
  background: #f1f5f9;
  color: #2563eb;
}
.user-dropdown-divider {
  height: 1px;
  background: #e5e7eb;
  margin: 0.2rem 0 0.2rem 0;
  width: 90%;
  margin-left: 5%;
  border-radius: 1px;
}
`}</style>;
